module.exports = __webpack_public_path__ + "img/img-script.8dc5fadb.png";